import summaryCommonStore from "@/store/summaryCommon.store";
import { useEffect, useMemo } from "react";
import SpeakerSummaryItem from "./SpeakerItem";
import summarySpeakerStore from "@/store/summarySpeaker.store";
import SummarySkeleton from "../SummarySkeleton";

export const SPEAKER_ITEM_ID_PREFIX = "speaker-item-";

const SpeakerSummary = () => {
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const speakerSummary = summarySpeakerStore((state) => state.speakerSummary);
  const newSpeakerSummary = summarySpeakerStore((state) => state.newSpeakerSummary);
  const avatarMap = summaryCommonStore((state) => state.avatarMap);
  const registryAvatar = summaryCommonStore((state) => state.getAvatar);
  const retryStatus = summaryCommonStore((state) => state.retryStatus);
  const speakerLoading = summarySpeakerStore((state) => state.speakerLoading);
  const isRetrying = retryStatus === 1;
  const currentSpeakerSummary = useMemo(() => speakerSummary?.srcSpeakers || speakerSummary?.srcSpeakers, [speakerSummary]);
  const renderingSpeakerSummary = useMemo(() => (summaryEditing ? newSpeakerSummary : currentSpeakerSummary), [summaryEditing, newSpeakerSummary, currentSpeakerSummary]);

  useEffect(() => {
    if (summaryEditing) {
      const dom = document.getElementById(SPEAKER_ITEM_ID_PREFIX + 0) as HTMLTextAreaElement;
      dom?.focus();
      dom?.setSelectionRange(dom.value.length, dom.value.length);
    }
  }, [summaryEditing]);

  return (
    <div className="flex flex-col gap-24px">
      {isRetrying || speakerLoading ? (
        <SummarySkeleton />
      ) : (
        renderingSpeakerSummary?.map((speaker, index) => (
          <SpeakerSummaryItem
            key={speaker.roleName + index}
            info={speaker}
            index={index}
            avatarSrc={avatarMap.get(speaker.roleName) || registryAvatar(speaker.roleName)}
            id={SPEAKER_ITEM_ID_PREFIX + index}
          />
        ))
      )}
    </div>
  );
};

export default SpeakerSummary;
